import { PROPERTY_DATA_API } from "../../apiList";

export default class BrokerageGateway {
    getAll(): Promise<any> {
        return PROPERTY_DATA_API.get("/brokerages");
    }
}
